export const toDisplayLicenseState = (licenseState?: string) => {
  if (!licenseState) {
    return undefined;
  }

  return licenseState.startsWith('CA-') ? 'Canada' : licenseState;
};
